// API Configuration
// You can modify this file to change the API base URL

export const API_CONFIG = {
  // Base URL for your backend API
  // Change this to your production URL when deploying
  BASE_URL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:9000',
  
  // API endpoints
  ENDPOINTS: {
    CONTACT_FORM: '/api/users/contact-form',
  }
};

// Helper function to get full API URL
export const getApiUrl = (endpoint) => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};
